import createProjectUpdatesWithLoading from '../utils/InterceptUploadLoading';

const getMyProjects = () => {
  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };
  return fetch(`my_projects`, requestOptions)
    .then((projects) => {
      return { projects: projects };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const getProjects = (perPage, page, ids) => {
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify({ ids }),
    redirect: 'follow',
  };
  return fetch(`projects?per_page=${perPage}&page=${page}`, requestOptions)
    .then((projects) => {
      return { projects: projects };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const getEventProjects = (perPage, page, ids) => {
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify({ ids }),
    redirect: 'follow',
  };
  return fetch(`events?per_page=${perPage}&page=${page}`, requestOptions)
    .then((projects) => {
      return { projects: projects };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const getSuccessfullEventProjects = (perPage, page, ids) => {
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify({ ids }),
    redirect: 'follow',
  };
  return fetch(
    `successful_events?per_page=${perPage}&page=${page}`,
    requestOptions
  )
    .then((projects) => {
      return { projects: projects };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const getAllSuccessfullEvent = (cat) => {
  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };
  return fetch(`category/successfull_projects?name=${cat}`, requestOptions)
    .then((projects) => {
      return { projects: projects };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const getRandomProjects = (projectId) => {
  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };
  const projectQuery = projectId
    ? `?project_id=${encodeURIComponent(projectId)}`
    : '';

  return fetch(`random_projects${projectQuery}`, requestOptions)
    .then((projects) => {
      return { projects: projects };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const getSuccessfulProjects = (perPage, page, ids) => {
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify({ ids }),
    redirect: 'follow',
  };
  return fetch(
    `projects_successful?per_page=${perPage}&page=${page}`,
    requestOptions
  )
    .then((projects) => {
      return { projects: projects };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const getHomeProjects = () => {
  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };
  return fetch(`projects/home_page`, requestOptions)
    .then((res) => {
      return { projects: res };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const getMySupportedProjects = () => {
  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };
  return fetch(`my_supported_projects`, requestOptions)
    .then((projects) => {
      return { projects };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const getMyLikedProjects = () => {
  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };
  return fetch(`my_liked_projects`, requestOptions)
    .then((projects) => {
      return { projects };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const showProject = (url) => {
  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };

  return fetch(`project/${url}`, requestOptions)
    .then((project) => {
      return { project: project };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const getProjectUrl = (projectId) => {
  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };

  return fetch(`projects/${projectId}/url`, requestOptions)
    .then((project) => project)
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const createDraft = (project) => {
  const raw = JSON.stringify({ project });
  const requestOptions = {
    method: 'POST',
    body: raw,
    redirect: 'follow',
  };
  return fetch(`projects/create_draft`, requestOptions)
    .then((project) => {
      return { project: project };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const createEmailRequest = (project) => {
  const raw = JSON.stringify({ project });
  const requestOptions = {
    method: 'POST',
    body: raw,
    redirect: 'follow',
  };
  return fetch(`projects/project_email_request`, requestOptions)
    .then((project) => {
      return { project: project };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const updateDraft = (projectId, project) => {
  const raw = JSON.stringify({ project });


  const isFormData = project instanceof FormData;

  let requestOptions = {}
  if(isFormData){
    requestOptions = {
      method: 'PUT',
      body: project,
      redirect: 'follow',
    };
  }else{
    requestOptions = {
      method: 'PUT',
      body: raw,
      redirect: 'follow',
    };
  }


  return fetch(`projects/${projectId}/update_draft`, requestOptions)
    .then((project) => {
      return { project: project };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const duplicateDraft = (projectId, url) => {
  const raw = JSON.stringify({ url });
  const requestOptions = {
    method: 'POST',
    body: raw,
    redirect: 'follow',
  };
  return fetch(`projects/${projectId}/duplicate_draft`, requestOptions)
    .then((project) => {
      return { project: project };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const uploadFiles = (projectId, formData) => {
  const requestOptions = {
    method: 'POST',
    body: formData,
    redirect: 'follow',
  };
  return fetch(`projects/${projectId}/upload_files`, requestOptions)
    .then((project) => {
      return { project: project };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const deleteDraft = (projectId) => {
  const requestOptions = {
    method: 'DELETE',
    redirect: 'follow',
  };
  return fetch(`projects/${projectId}/delete_draft`, requestOptions)
    .then(data => console.log(data))
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const reEditDraft = (projectId) => {
  const requestOptions = {
    method: 'PUT',
    redirect: 'follow',
  };
  return fetch(`projects/${projectId}/reedit_draft`, requestOptions)
    .then((project) => {
      return { project: project };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const uploadImages = (projectId, formData) => {
  const requestOptions = {
    method: 'PUT',
    body: formData,
    redirect: 'follow',
  };
  return fetch(`projects/${projectId}/update_draft`, requestOptions)
    .then((project) => {
      return { project: project };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const createEditReward = (projectID, reward) => {
  const raw = JSON.stringify({ ...reward });
  const requestOptions = {
    method: 'POST',
    body: raw,
    redirect: 'follow',
  };
  return fetch(`projects/${projectID}/rewards`, requestOptions)
    .then((project) => {
      return { project: project };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const uploadRewardImage = (rewardId, formData) => {
  const requestOptions = {
    method: 'PUT',
    body: formData,
    redirect: 'follow',
  };
  return fetch(`rewards/${rewardId}/upload_image`, requestOptions)
    .then((project) => {
      return { project: project };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const deleteReward = (rewardId) => {
  const requestOptions = {
    method: 'DELETE',
    redirect: 'follow',
  };
  return fetch(`rewards/${rewardId}`, requestOptions)
    .then((updates) => {
      return { updates };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const submitDraft = (projectId) => {
  const requestOptions = {
    method: 'PUT',
    redirect: 'follow',
  };
  return fetch(`projects/${projectId}/submit_draft`, requestOptions)
    .then((project) => {
      return { project: project };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const getBusinessType = (projectId) => {
  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };
  const queryParams = new URLSearchParams({
    project_id: projectId,
  });
  return fetch(
    `/payments/get_stripe_business_type?${queryParams.toString()}`,
    requestOptions
  )
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const checkUrl = (url) => {
  const raw = JSON.stringify({ project: { url } });
  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
    body: raw,
  };
  return fetch(`projects/check_url`, requestOptions)
    .then((result) => {
      return { isUniq: !result };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const getProjectCategories = () => {
  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };
  return fetch(`categories`, requestOptions)
    .then((categories) => {
      return { categories: categories };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const getProjectAdminCategories = () => {
  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };
  return fetch(`admin/categories`, requestOptions)
    .then((categories) => {
      return { adminCategories: categories };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const getProjectCreationCategories = () => {
  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };
  return fetch(`categories_for_creation`, requestOptions)
    .then((categories) => {
      return { categoriesCreation: categories };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const getProjectUpdates = (projectId) => {
  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };
  return fetch(`updates/${projectId}`, requestOptions)
    .then((updates) => {
      return { updates };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};


const getUpdateRecipientsCount = (projectId) => {
  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };
  return fetch(`updates/${projectId}/recipients_count`, requestOptions)
    .then((res) => res)
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const getUpdateDeliveryStatus = (projectId) => {
  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };
  return fetch(`updates/${projectId}/delivery_status`, requestOptions).catch(
    (error) => {
      return Promise.reject({ errors: error });
    }
  );
};

const resendProjectUpdate = (updateId) => {
  const requestOptions = {
    method: 'POST',
    redirect: 'follow',
  };
  return fetch(`updates/${updateId}/resend`, requestOptions).catch((error) => {
    return Promise.reject({ errors: error });
  });
};

// Abmelden von Update-Mails eines Projekts (ohne Login, signierter Token aus der Mail)
const updateUnsubscribeRequest = (method, token) => {
  const requestOptions = { method, redirect: 'follow' };
  if (method === 'GET') {
    return fetch(
      `update_unsubscribes?token=${encodeURIComponent(token)}`,
      requestOptions
    );
  }
  return fetch('update_unsubscribes', {
    ...requestOptions,
    body: JSON.stringify({ token }),
  });
};

// Schalter "Updates per E-Mail" je Projekt (angemeldete Nutzer)
const getUpdateSubscriptions = () =>
  fetch('update_subscriptions', { method: 'GET', redirect: 'follow' });

const resubscribeAllUpdates = () =>
  fetch('update_subscriptions/resubscribe_all', {
    method: 'POST',
    redirect: 'follow',
  });

const setUpdateSubscription = (projectId, receive) =>
  fetch(`update_subscriptions/${projectId}`, {
    method: 'PUT',
    redirect: 'follow',
    body: JSON.stringify({ receive }),
  });

const createProjectUpdates = (formdata, onProgress) => {
    return createProjectUpdatesWithLoading(formdata, onProgress);
};

// const createProjectUpdates = (formdata) => {
//   const requestOptions = {
//     method: 'POST',
//     redirect: 'follow',
//     body: formdata,
//   };
//
//   return fetch(`updates`, requestOptions)
//     .then((update) => {
//       return { update };
//     })
//     .catch((error) => {
//       return Promise.reject({ errors: error });
//     });
// };

const deleteProjectUpdates = async (updateId) => {
  const requestOptions = {
    method: 'DELETE',
    redirect: 'follow',
  };
  try {
    const updates = await fetch(`updates/${updateId}`, requestOptions);
    return { updates };
  } catch (error) {
    return await Promise.reject({ errors: error });
  }
};

const getProjectStatus = (id) => {
  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };
  return fetch(`projects/${id}/status`, requestOptions)
    .then((projectStatus) => {
      return { projectStatus };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const removeEdit = (id) => {
  const requestOptions = {
    method: 'PUT',
    redirect: 'follow',
  };
  return fetch(`projects/${id}/remove_edit`, requestOptions)
    .then((projectStatus) => {
      return { projectStatus };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const getProjectRewards = (id, forOwner = false) => {
  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };
  return fetch(
    `projects/${id}/rewards${forOwner ? '?for_order=1' : ''}`,
    requestOptions
  )
    .then((result) => result)
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const getRewardQuestions = (id) => {
  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };
  return fetch(`rewards/${id}/questions`, requestOptions)
    .then((result) => result)
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const getRewardVariants = (id) => {
  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };
  return fetch(`rewards/${id}/variants`, requestOptions)
    .then((result) => result)
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const getRewardOrder = (id, perPage, page) => {
  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };
  return fetch(
    `rewards/${id}/orders?per_page=${perPage}&page=${page}`,
    requestOptions
  )
    .then((result) => result)
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const getUserRewards = (perPage, page) => {
  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };
  return fetch(
    `user/rewards/orders?per_page=${perPage}&page=${page}`,
    requestOptions
  )
    .then((result) => result)
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const toggleOrderSent = (id) => {
  const requestOptions = {
    method: 'PUT',
    redirect: 'follow',
  };
  return fetch(`rewards/orders/${id}`, requestOptions)
    .then((project) => {
      return { project: project };
    })
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const likeProject = (projectId) => {
  const requestOptions = {
    method: 'POST',
    redirect: 'follow',
  };
  return fetch(`projects/${projectId}/like`, requestOptions)
    .then((result) => result)
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const unlikeProject = (projectId) => {
  const requestOptions = {
    method: 'DELETE',
    redirect: 'follow',
  };
  return fetch(`projects/${projectId}/like`, requestOptions)
    .then((result) => result)
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const shareProject = (projectId, channel) => {
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify({ channel }),
    redirect: 'follow',
  };
  return fetch(`projects/${projectId}/share`, requestOptions)
    .then((result) => result)
    .catch((error) => {
      return Promise.reject({ errors: error });
    });
};

const projectServices = {
  getMyProjects,
  getMySupportedProjects,
  getMyLikedProjects,
  showProject,
  getProjectUrl,
  createDraft,
  createEmailRequest,
  updateDraft,
  duplicateDraft,
  uploadFiles,
  deleteDraft,
  uploadImages,
  uploadRewardImage,
  createEditReward,
  deleteReward,
  submitDraft,
  getBusinessType,
  checkUrl,
  getProjectCategories,
  getProjectAdminCategories,
  getProjectCreationCategories,
  getProjects,
  getProjectUpdates,
  getUpdateRecipientsCount,
  getUpdateDeliveryStatus,
  resendProjectUpdate,
  updateUnsubscribeRequest,
  getUpdateSubscriptions,
  setUpdateSubscription,
  resubscribeAllUpdates,
  createProjectUpdates,
  deleteProjectUpdates,
  reEditDraft,
  getProjectStatus,
  getRandomProjects,
  getHomeProjects,
  removeEdit,
  getSuccessfulProjects,
  getProjectRewards,
  getRewardQuestions,
  getRewardVariants,
  getRewardOrder,
  toggleOrderSent,
  getUserRewards,
  getEventProjects,
  getSuccessfullEventProjects,
  getAllSuccessfullEvent,
  likeProject,
  unlikeProject,
  shareProject,
};

export default projectServices;
